import DynamicSectionElement from '@/js/dynamic-section-element';
import { updateElementState } from '@/js/element-states';
import '@oddbird/popover-polyfill';

class FlyoutCart extends DynamicSectionElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initVariables();
    this.setEventListeners();
    this.onLoadEventListeners();
  }

  /**
   * Initialize variables for the flyout cart
   * @returns {void}
   */
  initVariables() {
    this.bodyElement = document.body;
    this.buttonCheckout = this.querySelector('[data-btn-checkout]');
  }

  /**
   * Set event listeners for the flyout cart once
   * @returns {void}
   */
  onLoadEventListeners() {
    this.autoOpenCart = Object.hasOwn(this.dataset, 'autoOpenCart');

    if (this.autoOpenCart) {
      // Open flyout cart when custom event is fired
      document.addEventListener('pxl:addToCartSuccess', () =>
        this.showPopover()
      );
    }

    // Open the flyout cart if ?cart param is present in the URL; Remove param after.
    const url = new URL(globalThis.location);
    const parameters = url.searchParams;
    if (parameters.has('cart')) {
      this.showPopover();
      parameters.delete('cart');
      globalThis.history.replaceState({}, '', url.toString());
    }
  }

  /**
   * Set event listeners for the flyout cart
   * @returns {void}
   */
  async setEventListeners() {
    // Add an event listener to set a loading spinner on the checkout button
    if (this.buttonCheckout) {
      this.buttonCheckout.addEventListener('click', () => {
        updateElementState(this.buttonCheckout, 'loading');
      });
    }

    // Listen for the popover toggle event, and the set the aria-hidden attribute and cart-open attribute
    this.addEventListener('beforetoggle', event => {
      const ariaValue = event.newState === 'closed' ? 'true' : 'false';
      this.ariaHidden = ariaValue;
      this.bodyElement.setAttribute('cart-open', event.newState === 'open');

      // Focus the flyout cart when it's opened
      // the close button is the first focusable element in the flyout cart
      if (event.newState === 'open') {
        const closeButton = this.querySelector('[data-close-flyout-cart]');
        if (closeButton) {
          closeButton.focus();
        }
      }
    });
  }

  afterSectionRender() {
    this.initVariables();
    this.setEventListeners();
  }
}

customElements.get('flyout-cart') ||
  customElements.define('flyout-cart', FlyoutCart);
